module.exports = __webpack_public_path__ + "img/header-weddingRingsHearts.f410b6f.jpg";